<mat-form-field hidden appearance="outline">
  <input matInput type="text" [formControl]="controle" />
</mat-form-field>
